import {httpClient} from '../../common/api/HttpClient';

export const teamApi = {
    getTeamsOfClub: (clubId) =>
        clubId ?
            httpClient.get(`teams/?clubId=${clubId}`) :
            httpClient.get(`teams/`)
    ,
    createOrUpdateTeam: (team) =>
        httpClient.post('teams/', team),
    delete: (id) => httpClient.delete(`teams/?teamId=${id}`)

};

export default teamApi;
